import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import config from '../Common_Files/Config';
const API_URL = `${config.api_url}/ws-get-suppliers`;

const SupplierSearch = ({ setSearchSupplier, value, placeholder = 'Select Supplier' }) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  

  useEffect(() => {  
    const fetchOptions = async () => {
      try {
        const response = await axios.get(API_URL);
        const list = Array.isArray(response.data?.supplier) ? response.data.supplier : [];
        setOptions(list.map(item => ({
          value: item.id,
          label: item.name
        })));
      } catch (err) {
        setError('Failed to fetch options');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchOptions();
  }, []);

  const handleChange = (selectedOption) => {
    setSearchSupplier(selectedOption ? selectedOption.value : '');
  };

  
  const selectedValue = value !== "" && value != null
    ? options.find((opt) => String(opt.value) === String(value)) || null
    : null;

  return (
    <Select
      name="supplier_id"
      options={options}
      value={selectedValue}
      onChange={handleChange}
      placeholder={placeholder}
      isSearchable
      isClearable
      isLoading={isLoading}
      components={{ IndicatorSeparator: () => null }}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
    />
  );
};

export default SupplierSearch;
